import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Panel, Spinner, Empty, Time, UserChip } from "@/forum/ui";
import { ThreadRow } from "./CategoryPage";

export default function SearchPage() {
  const [sp] = useSearchParams();
  const q = sp.get("q") || "";
  const [data, setData] = useState(null);
  const { user } = useAuth();

  useEffect(() => {
    if (user === null) return;
    setData(null);
    api.get("/forum/search", { params: { q } }).then((r) => setData(r.data));
  }, [q, user]);

  return (
    <div className="space-y-6" data-testid="search-page">
      <div>
        <p className="eyebrow mb-3">Keresés</p>
        <h1 className="font-display text-3xl font-bold">„{q}”</h1>
      </div>
      {!data ? <Spinner /> : (
        <>
          <section className="space-y-3">
            <h2 className="font-mono text-[11px] uppercase tracking-[0.25em] text-white/50">Témák ({data.threads.length})</h2>
            <Panel className="overflow-hidden">
              {data.threads.length ? <div className="divide-y divide-white/[0.05]">{data.threads.map((t) => <ThreadRow key={t.id} t={t} />)}</div> : <Empty text="Nincs találat a témák között" testId="no-thread-results" />}
            </Panel>
          </section>
          <section className="space-y-3">
            <h2 className="font-mono text-[11px] uppercase tracking-[0.25em] text-white/50">Hozzászólások ({data.posts.length})</h2>
            {data.posts.length ? data.posts.map((p) => (
              <Panel key={p.id} className="p-5" data-testid={`search-post-${p.id}`}>
                <div className="mb-2 flex items-center justify-between gap-3">
                  <UserChip user={p.author} />
                  <Time iso={p.created_at} />
                </div>
                <p className="line-clamp-3 text-sm text-white/70">{p.content}</p>
                <Link to={`/forum/t/${p.thread_id}`} className="mt-3 inline-block font-mono text-[11px] text-[var(--glow)] hover:underline">→ {p.thread_title}</Link>
              </Panel>
            )) : <Empty text="Nincs találat a hozzászólások között" testId="no-post-results" />}
          </section>
        </>
      )}
    </div>
  );
}
